import LiveLesson from './LiveLesson'

/** Страница live-урока */
export function LiveLessonPage() {
	return <LiveLesson />
}
